import { createContext, useContext } from "react";

import { PropTypes } from "prop-types";

import useGetUserLicenses from "@/view/utils/useGetUserLicenses";

const propTypes = {
  children: PropTypes.node.isRequired,
};

export const UserLicensesContext = createContext([]);

export const UserLicensesProvider = ({ children }) => {
  const userLicenses = useGetUserLicenses();

  return (
    <UserLicensesContext.Provider value={userLicenses}>
      {children}
    </UserLicensesContext.Provider>
  );
};

UserLicensesProvider.propTypes = propTypes;

const useUserLicenses = () => {
  return useContext(UserLicensesContext);
};

export default useUserLicenses;
